<template>
  <div v-if="isReady" id="container">
    <div class="flex flex-col items-center">
      <img src="@/assets/images/hwak/done-icon.png" class="mt-5 sm:w-16 w-1/3" />
      <h3 class="mt-5 text-center font-bold text-2xl text-primary">
        Booking Preview.
      </h3>
    </div>

    <div class="w-full mt-5">
      <table class="md:w-6/12 mx-auto text-gray-700 border-collapse">
        <tbody>
          <tr class="border-b">
            <td class="font-bold pr-4 py-2">Booking No</td>
            <td id="receiptNo" class="py-2">: {{ res.BookNr }}</td>
          </tr>
          <tr class="border-b">
            <td class="font-bold pr-4 py-2">Reference No</td>
            <td id="receiptNo" class="py-2">: {{ res.RefNo }}</td>
          </tr>
          <tr class="border-b">
            <td class="font-bold pr-4 py-2">Customer Name</td>
            <td id="CusName" class="py-2">: {{ res.Client.FullName }}</td>
          </tr>
          <tr class="border-b">
            <td class="font-bold pr-4 py-2">Pickup Date</td>
            <td id="Hotel-Venue" class="py-2">: {{ pickupDate }}</td>
          </tr>
          <tr class="border-b">
            <td class="font-bold pr-4 py-2">Pickup Place</td>
            <td id="Hotel-Venue" class="py-2">: {{ res.Pickup.Place.Name }}</td>
          </tr>
          <tr class="border-b">
            <td class="font-bold pr-4 py-2">Dropoff Date</td>
            <td id="Hotel-Venue" class="py-2">: {{ DropoffDate }}</td>
          </tr>
          <tr class="border-b">
            <td class="font-bold pr-4 py-2">Dropoff Place</td>
            <td id="Hotel-Venue" class="py-2">: {{ res.Dropoff.Place.Name }}</td>
          </tr>
          <tr class="border-b">
            <td class="font-bold pr-4 py-2">Car</td>
            <td id="Hotel-Venue" class="py-2">: {{ res.VehicleGroupReserved.ShortDescription }}</td>
          </tr>
          <tr class="border-b">
            <td class="font-bold pr-4 py-2">Bill Amount</td>
            <td id="bill-amt" class="py-2">: RM {{ res.Charges.ClientCharges.Total }}</td>
          </tr>
          <tr class="border-b">
            <td class="font-bold pr-4 py-2">Discounted Price</td>
            <td id="bill-amt" class="py-2">: RM {{ calculateDiscountedPrice() }}</td>
          </tr>
        </tbody>
      </table>
      <div v-if="results" class="results-table">
      <!-- <table  class="md:w-6/12 mx-auto text-gray-700 border-collapse">
        <thead>
          <tr>
            <th>Discounted Price</th>
            <th>Upfront Payment (20%)</th>
            <th>Remaining Balance</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>{{ results.discountedPrice }}</td>
            <td>{{ results.upfrontPayment }}</td>
            <td>{{ results.remainingBalance }}</td>
          </tr>
        </tbody>
      </table> -->
    </div>
      <div class="text-center mt-5">

        <button @click="confirmBookingCancelation('You are about to make a payment for your booking.', 'full')"
          class="print:hidden bg-primary hover:bg-primary-dark text-white font-bold py-3 px-6 text-lg rounded m-2">
          Pay Now & Get 5% Off
        </button>
        <button @click="confirmBookingCancelation('You are going pay at the counter.', 'Over-the-counter')"
          class="print:hidden bg-primary hover:bg-primary-dark text-white font-bold py-3 px-6 rounded m-2">
          Pay at the Counter
        </button>
        <br>
        <button @click="confirmBookingCancelation('You are about to cancel your booking', 'cancel')"
          class="print:hidden bg-warning hover:bg-primary-dark text-white font-bold py-2 px-4 rounded m-2">
          Cancel Booking
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import { axiosMixin } from "@/mixin/axiosMixin";
import { alertMixin } from "@/mixin/alertMixin";
export default {
  mixins: [axiosMixin, alertMixin],
  data() {
    return {
      res: this.$store.state.main.reservation,
      isReady: false,
      paymentType: "",
      results:  null,

    };
  },
  computed: {
    pickupDate() {
      return this.res.Pickup.Date.replace('T', ' ').replace(':00', '');
    },
    DropoffDate() {
      return this.res.Dropoff.Date.replace('T', ' ').replace(':00', '');
    }
  },
  methods: {
    printPage() {
      window.print();
    },
    startLoading() {
      this.$vs.loading({
        container: "#container",
        scale: 0.6,
      });
    },
    stopLoading() {
      this.$vs.loading.close("#container > .con-vs-loading");
    },
    confirmBookingCancelation(msg, paymentType) {
      this.paymentType = paymentType;
      this.$vs.dialog({
        class: 'dialog-front', // Add this line
        type: 'confirm',
        color: 'danger',
        title: `Confirm`,
        acceptText: "Yes",
        cancelText: "No",
        text: msg,
        accept: this.buttonAction,
        cancel: () => {
          this.showDialog = true;
        }
      })
    },
    buttonAction() {
      if (this.paymentType == "cancel") {
        this.cancelBooking();
      } else {
        this.payNow();
      }
    },
    payNow() {
      var payload = {
        refNo: this.res.RefNo,
        paymentType: this.paymentType,
        // other required fields
      }
      this.aronPost("payments", payload, "", "")
        .then((response) => {
          console.log(response.status);
          console.log(response.data.url);
          if (response.status == 200) {
            ///  window.open(response.data.url, '_blank');
            if (response.data.status != "error") {
              window.location.href = response.data.url;
            } else {
              this.errorAlert("Error", response.data.message);
            }
          }
        }).catch(error => {
          console.error(error);
        });
    },
    cancelBooking() {
      this.startLoading();
      this.aronPost("cancelBooking", { refNo: this.res.RefNo }, "", "")
        .then((response) => {
          if (response.data.status == "200") {
            this.successAlert("Success", "Booking Cancelled Successfully");
            this.$emit('update:showManageBooking', false); // Close the dialog only on success

          } else {
            this.errorAlert("Error", "Booking Number does not exist!");
            // Do not close the dialog if there is an error
          }
          this.stopLoading();
        })
        .catch((error) => {
          console.log("error:", error);
          this.errorAlert("Error", "An unexpected error occurred.");
          this.stopLoading();
        });
    },
    calculateDiscountedPrice() {
      var totalAmount = this.res.Charges.ClientCharges.Total;
      const discountRate = 0.05; // 5% discount
      const discountedPrice = totalAmount - totalAmount * discountRate;
      return discountedPrice.toFixed(2);
    },
    calculatePayments() {
      var totalAmount = this.res.Charges.ClientCharges.Total;

      const discountRate = 0.05; // 5% discount
      const upfrontRate = 0.2; // 20% upfront

      // Step 1: Calculate discounted price
      const discountedPrice = totalAmount - totalAmount * discountRate;

      // Step 2: Calculate upfront payment
      const upfrontPayment = discountedPrice * upfrontRate;

      // Step 3: Calculate remaining balance
      const remainingBalance = discountedPrice - upfrontPayment;

      // Save results
      this.results = {
        discountedPrice: discountedPrice.toFixed(2),
        upfrontPayment: upfrontPayment.toFixed(2),
        remainingBalance: remainingBalance.toFixed(2),
      };
    },
  },

  created() {
  },
  mounted() {

    if (!this.res) {
     this.$router.replace("/booking");
    }

    this.calculatePayments();
    this.isReady = true;
  }
};
</script>
<style scoped>
.text-primary {
  color: #3490dc;
  /* Customize with your primary color */
}

.mt-5 {
  margin-top: 1.25rem;
}

.sm\:w-16 {
  width: 4rem;
}

.font-bold {
  font-weight: bold;
}

.text-center {
  text-align: center;
}

.text-2xl {
  font-size: 1.5rem;
}

.md\:w-6\/12 {
  width: 50%;
}

.mx-auto {
  margin-left: auto;
  margin-right: auto;
}

.text-gray-700 {
  color: #4a5568;
}

.pr-4 {
  padding-right: 1rem;
}

.py-2 {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}

.border-b {
  border-bottom: 1px solid #e2e8f0;
}

/* Hide print button when printing */
@media print {
  .print\:hidden {
    display: none;
  }
}
</style>
